import Avatar from '@component/avatar'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import { AgentCardReviewStar } from '@component/reviewStar'
import { agentDetail } from '@router'
import { getColliersClassName, showReview } from '@utils'
import { get } from 'lodash-es'
import AgentEmailButton from '../button/email'
import OfficeLine from '../officeLine'

export default function AgentRreview({
  data
}) {

  const isShowReview = showReview(data)
  const Wrap = isShowReview ? DisablePrefetchLink : 'div'

  return (
    <Wrap {...(isShowReview ? { href: agentDetail(data) } : {})} className='h-294 flex flex-col'>
      <OfficeLine data={data.office} bgColor={data.bgColor} center iconHeight={30} className='!h-40 rounded-t-sm'></OfficeLine>
      <div className='p-16 border border-t-0 flex-1 min-h-0 rounded-b-sm flex flex-col'>
        {
          isShowReview
            ? (
              <>
                <div className='flex'>
                  <div className='flex-1 min-w-0'>
                    <div className='text-sm'>{data.name}</div>
                    <div className='text-xs text-neutral-5 line-clamp-1'>{data.jobTitle}</div>
                    <AgentCardReviewStar
                      score={get(data, 'rateStat.avgScore', '0.0')}
                      count={get(data, 'rateStat.reviewCount', 0)}
                      className='mt-4'
                    ></AgentCardReviewStar>
                  </div>
                  <Avatar src={data.icon} circle alt={data.name} width={48} height={48} defaultIcon='icon-avatar' iconSize='!text-xl' className={getColliersClassName(data.office)}></Avatar>
                </div>
                <div className='flex border-t border-b py-6 mt-auto'>
                  <div className='flex-1 text-center'>
                    <div className='text-base text-font font-bold'>{data.soldValue || '-'}</div>
                    <div className='text-sm'>Average sale</div>
                  </div>
                  <div className='flex-1 text-center'>
                    <div className='text-base text-font font-bold'>{data.soldNum || '-'}</div>
                    <div className='text-sm'>Sold</div>
                  </div>
                </div>
                <AgentEmailButton data={data} className='mt-12'>Get an appraisal</AgentEmailButton>
              </>
            )
            : (
              <>
                <div className='flex items-center gap-x-8'>
                  <Avatar src={data.icon} circle alt={data.name} width={48} height={48} defaultIcon='icon-avatar' iconSize='!text-xl'></Avatar>
                  <div className='flex-1 min-w-0'>
                    <div className='text-sm'>{data.name}</div>
                    <div className='text-xs text-neutral-5 line-clamp-1'>{data.jobTitle}</div>
                  </div>
                </div>
                <div className='mt-12 flex gap-x-10 text-sm'>
                  <div className='flex-1 bg-neutral-1 py-8 px-16 rounded-sm'>
                    <div>Average sale price</div>
                    <div>{data.soldValue || '-'}</div>
                  </div>
                  <div className='bg-neutral-1 py-8 px-16 rounded-sm'>
                    <div>Sold</div>
                    <div>{data.soldNum || '-'}</div>
                  </div>
                </div>
                <DisablePrefetchLink href={agentDetail(data)} className='button-primary-out w-full mt-12'>View profile</DisablePrefetchLink>
                <AgentEmailButton data={data} className='mt-12'>Get an appraisal</AgentEmailButton>
              </>
            )
        }
      </div>
    </Wrap>
  )
}